var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-row",
    { ref: "mainPlayer", staticStyle: { width: "100%", height: "100%" } },
    [
      _vm.element.streamMediaLinks[_vm.element.streamMediaLinks.videoType].url
        ? _c("div", { staticClass: "video-container" }, [
            _c("video", {
              ref: "player-" + _vm.element.id,
              staticClass: "centered-video",
              attrs: {
                name: "centeredVideo",
                loop: _vm.pOption.loop,
                controls: _vm.inScreen,
                muted: "",
              },
              domProps: { muted: true },
            }),
            _vm.editMode === "edit"
              ? _c("div", { staticClass: "stream-mask edit-mask-stream" })
              : _vm._e(),
            _vm.mobileLayoutStatus
              ? _c("div", { staticClass: "stream-mask" }, [
                  _c("span", { staticStyle: { opacity: "0.7" } }, [
                    _c("span", { staticStyle: { color: "lightgray" } }, [
                      _vm._v(_vm._s(_vm.$t("panel.stream_mobile_tips"))),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ])
        : _c("div", { staticClass: "info-stream-class" }, [
            _c("span", [_vm._v(_vm._s(_vm.$t("panel.link_add_tips_pre")))]),
            _c("i", { staticClass: "icon iconfont icon-chaolianjie" }),
            _c("span", [_vm._v(_vm._s(_vm.$t("panel.stream_media_add_tips")))]),
          ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }